const isTouchDevice =
	'ontouchstart' in window && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent);
export default function getIsTouchDevice() {
	return isTouchDevice;
}
